import dayjs from 'dayjs';
import buddhistCalendar from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';

dayjs.extend(buddhistCalendar);
dayjs.locale('th');

export default dayjs;
